<script>
  import {Line, mixins} from 'vue-chartjs'

  export default {
    extends: Line,
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    data () {
      let that = this

      return {
        options: {
          elements: {
            point: {
              radius: 0
            }
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                autoSkipPadding: 50,
                maxRotation: 0
              }
            }],
            yAxes: [{
              display: false
            }]
          },
          tooltips: {
            backgroundColor: 'rgba(220, 220, 220, 0.8)',
            bodyFontColor: '#000',
            bodySpacing: 5,
            labelColor: '#000',
            callbacks: {
              title: function (tooltipItem, data) {
                return null
              },
              label: function (tooltipItem, data) {
                let dataset = data.datasets[tooltipItem.datasetIndex]
                let index = tooltipItem.index
                return `${dataset.labels[index]}: ${that.$currency}${tooltipItem.yLabel}`
              }
            },
            cornerRadius: 0,
            intersect: false,
            mode: 'label',
            xPadding: 10,
            yPadding: 10
          }
        }
      }
    },
    mounted () {
      this.renderChart(this.chartData, this.options)
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/charts/LineChart.vue